
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../util';
import InventoryTab from './inventory/InventoryTab';
import BinTab from './bin/BinTab';
import StockTakingTab from './stockTaking/StockTakingTab';

declare var window: WindowType;

@Component({
  name: 'inventory',
  components: {
    BinTab,
    InventoryTab,
    StockTakingTab,
  },
})
export default class InventoryComponent extends Vue {
  tab: 'inventory' | 'bin' | 'stockTaking' = 'inventory';

  get canBins(): boolean {
    return window.application.permissions.maintenance.inventory.bin.bin;
  };

  get canStockTaking(): boolean {
    return window.application.permissions.maintenance.inventory.stockTaking.management;
  };
}
